import { I2079Form } from 'clickNgo/models/crud/forms'

import { EngagementPrediction } from '../model/types'

export const mapEngagementPrediction = (data: I2079Form): EngagementPrediction => ({
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
  entryId: data.EntryId,
  partnerId: data.PID,
  partnerName: data.PARTNER_NAME,
  flagPc: data.FLAG_PC,
  flagPrint: data.FLAG_PRINT,
  flagSupplies: data.FLAG_SUPPLIES,
  flagAll: data.FLAG_ALL,
  hpOrganization: data.HP_ORGANIZATION,
  country: data.COUNTRY,
  salesRep: data.SALES_REP,
  salesRepMailId: data.SALES_REP_MAIL_ID,
  hpOrgRank: data.HP_ORG_RANK,
  countryRank: data.COUNTRY_RANK,
  agentRank: data.AGENT_RANK,
  timestampForPred: data.TIMESTAMP_FOR_PRED,
  month: data.MONTH,
  quarter: data.QUARTER,
})
